import { render, staticRenderFns } from "./it-chart-component.vue?vue&type=template&id=3c9a8557"
import script from "./it-chart-component.vue?vue&type=script&lang=js"
export * from "./it-chart-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports